import { WhatsNew } from 'features/whats-new';

export function WhatsNewRoute() {
  return <WhatsNew />;
}
